import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import "./fonts/DIN Next LT Arabic Light.ttf";
import "./fonts/TheSansArab-Black.ttf";
import "./fonts/TheSansArab-Bold.ttf";
import "./fonts/TheSansArab-Light.ttf";
import "./fonts/TheSansArab-Plain.ttf";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

ReactDOM.render(
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<Navigate to={{ pathname: "/dashboard" }} />} />
      <Route path="/dashboard" element={<App />} />
    </Routes>
  </BrowserRouter>,
  document.getElementById("root")
);
